import React from "react"
import ReactDOM from "react-dom"
import JuicerFeedComponent from "./juicer-feed-component"

export default class JuicerFeedModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<JuicerFeedComponent {...self.modelJson} />, self.elem)
  }
}
